const timeShift = [
  {
    stdIn: 8,
    minuteIn: 30,
    stdOut: 17,
    minuteOut: 30,
  },
  {
    stdIn: 9,
    minuteIn: 0,
    stdOut: 18,
    minuteOut: 0,
  },
];

export const getTimeShift = (logTime: Date | string) => {
  const date = new Date(logTime);

  const totalMinutes = date.getHours() * 60 + date.getMinutes();

  const shift = totalMinutes <= 8 * 60 + 30 ? timeShift[0] : timeShift[1];

  const stdIn = new Date(date);
  const stdOut = new Date(date);

  const shiftStartMinutes = shift.stdIn * 60 + shift.minuteIn;

  if (totalMinutes > shiftStartMinutes) {
    stdIn.setTime(date.getTime());
  } else {
    stdIn.setHours(shift.stdIn, shift.minuteIn, 0, 0);
  }

  stdOut.setHours(shift.stdOut, shift.minuteOut, 0, 0);

  return {
    stdIn,
    stdOut,
    shift,
  };
};
export const getTimeShiftIn = (logTime: Date) => {
  const { stdIn, stdOut, shift } = getTimeShift(logTime);
  const lateMinutes = Math.max(
    0,
    Math.floor((logTime.getTime() - stdIn.getTime()) / 60000),
  );
  return {
    lateMinutes,
    stdIn,
    stdOut,
    shift,
  };
};

export const getTimeShiftOut = (checkOut: Date, stdOut: Date) => {
  const earlyMinutes = Math.max(
    0,
    Math.floor((stdOut.getTime() - checkOut.getTime()) / 60000),
  );
  return { earlyMinutes };
};

export const actualOTHours = (checkOut: Date, stdOut: Date) => {
  const diff = (checkOut.getTime() - stdOut.getTime()) / (1000 * 60 * 60);
  return Math.max(0, Number(diff.toFixed(2)));
};
